import { Component } from '@angular/core';

@Component({
  selector: 'app-access-denied',
  template: `
    <main class="access-denied">
      <h1>Access denied</h1>
      <p>This form can only be opened from the trusted host application.</p>
    </main>
  `,
  styles: [`
    .access-denied {
      min-height: 100vh;
      display: grid;
      place-items: center;
      padding: 2rem;
      text-align: center;
      background: #f5f7fa;
      color: #17324d;
    }

    h1 {
      margin: 0 0 0.75rem;
      font-size: 2rem;
    }

    p {
      margin: 0;
      max-width: 32rem;
      font-size: 1rem;
      line-height: 1.5;
    }
  `]
})
export class AccessDeniedComponent {
}